module.exports = __webpack_public_path__ + "static/media/3-10.93c2caef.mp3";